// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lzhc","right":"styles_right__2RtNU"};